import React, { useEffect, useRef, useState } from 'react';
import * as THREE from 'three'
import { Text } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'

interface IWordProps {
  children?: React.ReactNode;
  position: THREE.Vector3;
}

const Word:React.FC<IWordProps> = ({ children, ...props }) => {
  const color = new THREE.Color()
  const fontProps = {
    //font: "/Inter-Bold.woff",
    fontFamily: "'Poppins', sans-serif",
    fontSize: 2.5,
    letterSpacing: -0.05,
    lineHeight: 1,
    "material-toneMapped": false,
  };
  const ref = useRef();
  const [hovered, setHovered] = useState(false);
  const over = (e: any) => (e.stopPropagation(), setHovered(true));
  const out = () => setHovered(false);

  // Change the mouse cursor on hover
  useEffect(() => {
    if (hovered) {
      document.body.style.cursor = 'pointer'
    };

    return () => {
      document.body.style.cursor = 'auto'
    }
  }, [hovered])
  // Tie component to the render-loop
  useFrame(({ camera }) => {
    if (!ref.current) return;
    // Make text face the camera
    // @ts-ignore
    ref.current.quaternion.copy(camera.quaternion)

    const textColorVar = document.documentElement.style.getPropertyValue('--color-text').trim();
    const primaryColorVar = document.documentElement.style.getPropertyValue('--color-primary').trim();
    // Animate font color
    // @ts-ignore
    ref.current.material.color.lerp(color.set(hovered ? primaryColorVar : textColorVar), .1)
  })

  return (
    // trunk-ignore(eslint/react/no-children-prop)
    <Text ref={ref} onPointerOver={over} onPointerOut={out} {...props} {...fontProps} children={children} />
  )
}

export default Word;
